import React from 'react';
import { OidcProvider, CallbackComponent } from 'redux-oidc';
import useUserManager from '@ers/authorization/userManager';
import { Content, Body, Spinner } from '@ers/ui';
import { SentryLogger as Sentry } from '@ers/errors';
import store from '../App.store';

const CallbackPage = () => {
    const userManager = useUserManager();
    return (
        <OidcProvider userManager={userManager} store={store}>
            <CallbackComponent
                userManager={userManager}
                successCallback={(response) => {
                    try {
                        localStorage.removeItem('signinRetry');
                        window.history.replaceState({},
                            window.document.title,
                            window.location.origin + window.location.pathname);
                        window.location.replace(response.state);
                    } catch (error) {
                        Sentry.error(error);
                    }
                }}
                errorCallback={(error) => {
                    // eslint-disable-next-line no-console
                    try {
                        if (error.message === 'No matching state found in storage') {
                            if (localStorage.getItem('signinRetry') === true) {
                                localStorage.removeItem('signinRetry');

                                Sentry.error(error);
                            } else {
                                localStorage.setItem('signinRetry', true);
                                userManager.signinRedirect({ data: window.location.origin });
                            }
                        } else if (error.message === 'No state in response') {
                            if (localStorage.getItem('signinRetry') === true) {
                                localStorage.removeItem('signinRetry');
                                Sentry.error(error);
                            } else {
                                localStorage.setItem('signinRetry', true);
                                window.history.replaceState({},
                                    window.document.title,
                                    window.location.origin + window.location.pathname);
                                window.location.replace(window.location.origin);
                            }
                        } else if (error.message === 'invalid_grant') {
                            window.history.replaceState({},
                                window.document.title,
                                window.location.origin + window.location.pathname);
                            window.location.replace(window.location.origin);
                        } else {
                            Sentry.error(error);
                        }
                    } catch (er) {
                        Sentry.error(er);
                    }
                }}
            >
                <Content>
                    <Body>
                        <Spinner.Plate />
                    </Body>
                </Content>
            </CallbackComponent>
        </OidcProvider>
    );
};

export default CallbackPage;
